import * as React from 'react';

// types
import { ITranslationProps } from 'types/translation';

// components
import PageSupportBlockContainer from 'modules/page-support-block';

// utils
import { translate } from 'components/translate-hoc';
import AnalyticsService from 'modules/analytics-provider/analytics-provider.service';

// constants
import { ERROR_KEYS } from 'constants/app.constants.ts';
import { TEXT_KEYS, ERROR_FLOW_STEP, ERROR_TRACKING_DETAILS } from './error-page.constants';
import { ERROR_TYPES } from 'modules/event-manager/event-manager-error';
import { CATEGORY } from 'modules/analytics-provider/analytics-provider.constants';

import './error-page.styles.less';

export class ErrorPage extends React.PureComponent<IErrorPageProps> {
    public componentDidMount() {
        const { errorType, maintenanceMode } = this.props;
        const error = maintenanceMode ? ERROR_TYPES.ERROR_MAINTENANCE : errorType;
        AnalyticsService.sendFlowEvent({
            ...ERROR_FLOW_STEP,
            category: CATEGORY.DISPLAY,
            flowStepDetails: ERROR_TRACKING_DETAILS[error],
            action: `error : ${ERROR_TRACKING_DETAILS[error]}`
        });
    }

    public render() {
        const { dangerouslyTranslateWithHTML: translateKey, errorType, maintenanceMode } = this.props;
        const error = maintenanceMode ? ERROR_TYPES.ERROR_MAINTENANCE : errorType;

        const title: string = translateKey(ERROR_KEYS.WIDGET_ERROR_TITLE);
        const content: string = translateKey(TEXT_KEYS.MESSAGE[error] || ERROR_KEYS.WIDGET_ERROR_MESSAGE);

        return (
            <div className="sitegen-free-content-error">
                <div className="sitegen-free-content-error__title">{title}</div>
                <div className="sitegen-free-content-error__content">{content}</div>
                <PageSupportBlockContainer flowStepDetails={ERROR_TRACKING_DETAILS[error]}/>
            </div>
        );
    }
}

export interface IErrorPageStoreProps {
    readonly errorType: string;
    readonly maintenanceMode: boolean;
}

export type IErrorPageProps = IErrorPageStoreProps & ITranslationProps;

export default translate()(ErrorPage);
